export const getFootnoteListId = (citeId: string) => `cite-${citeId}`;

export const getFootnoteRefId = (citeId: string) => `cite-ref-${citeId}`;
